import { X } from "lucide-react";
import { ReactNode } from "react";
import { cn } from "../../../utils";
import { Typography } from "../Typography";
import { Button } from "../Button";

type TFilterChipProps = {
  label: string;
  value: ReactNode;
  onClear?: () => void;
  variant?: "blue" | "green" | "amber" | "indigo";
  ariaLabel?: string;
  showCloseIcon?: boolean;
  id?: string;
};

const variantStyles = {
  blue: {
    container: "border-blue/20 bg-blue/11",
    text: "text-blue",
    button: "text-blue hover:text-blue/70",
  },
  green: {
    container: "border-green/20 bg-green/10",
    text: "text-green",
    button: "text-green hover:text-green/70",
  },
  amber: {
    container: "border-amber/20 bg-amber/11",
    text: "text-amber",
    button: "text-amber hover:text-amber/70",
  },
  indigo: {
    container: "border-indigo/20 bg-indigo/11",
    text: "text-indigo",
    button: "text-indigo hover:text-indigo/70",
  },
};

const FilterChip = ({
  label,
  value,
  onClear,
  variant = "blue",
  ariaLabel = "Clear filter",
  showCloseIcon = true,
  id,
}: TFilterChipProps) => {
  const styles = variantStyles[variant];

  return (
    <div
      className={cn(
        "flex items-center rounded-full border px-3 py-1 text-sm",
        showCloseIcon && "gap-1",
        styles.container,
      )}
      data-testid="filter-chip"
      data-variant={variant}
    >
      <div className="flex items-center">
        <Typography
          variant={"article"}
          affects={"semiBold"}
          className={cn("text-sm", styles.text)}
        >
          {label}:
        </Typography>
        <Typography
          variant={"article"}
          className={cn("ml-1 text-sm", styles.text)}
        >
          {value}
        </Typography>
      </div>
      {showCloseIcon && onClear && (
        <Button
          variant="ghost"
          size="xs"
          onClick={onClear}
          className={cn("transition-colors", styles.button)}
          aria-label={ariaLabel}
          id={`${id}-close-button`}
        >
          <X size={14} />
        </Button>
      )}
    </div>
  );
};

export default FilterChip;
